import React, { useState } from 'react';
import './Applications.css';

const Applications = () => {
  const [activeTab, setActiveTab] = useState('rolnictwo');

  const tabs = [
    {
      id: 'rolnictwo',
      title: 'Rolnictwo 4.0',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 22V8.5a4.5 4.5 0 0 0-4.5-4.5H4a2 2 0 0 1-2-2"></path>
          <path d="M14.5 4a4.5 4.5 0 0 0 0 9h5"></path>
          <path d="M4 22V12c0-.5.5-1 1-1h9c.5 0 1 .5 1 1v10"></path>
          <line x1="12" y1="16" x2="12" y2="16.01"></line>
        </svg>
      ),
      title2: 'Zaawansowane rolnictwo',
      description: 'Inteligentna automatyzacja procesów uprawnych i hodowlanych',
      benefits: [
        'Redukcja zużycia wody o 30-40%',
        'Optymalne wykorzystanie nawozów (oszczędności 25-35%)',
        'Wczesne wykrywanie chorób roślin i szkodników',
        'Prognozowanie plonów z dokładnością 95%'
      ]
    },
    {
      id: 'energia',
      title: 'Smart Grid',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
      ),
      title2: 'Inteligentne sieci energetyczne',
      description: 'Optymalizacja produkcji i dystrybucji energii',
      benefits: [
        'Zwiększenie stabilności mikrosieci o 45%',
        'Redukcja strat przesyłowych o 18%',
        'Optymalne wykorzystanie lokalnej produkcji energii odnawialnej',
        'Elastyczne reagowanie na zmiany w sieci i zapotrzebowaniu'
      ]
    },
    {
      id: 'logistyka',
      title: 'Smart Logistics',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
          <path d="M10 9H8"></path>
        </svg>
      ),
      title2: 'Inteligentna logistyka',
      description: 'Zaawansowane zarządzanie łańcuchem dostaw',
      benefits: [
        'Skrócenie czasu realizacji zamówień o 37%',
        'Redukcja kosztów transportu o 24%',
        'Zmniejszenie poziomów zapasów o 32%',
        'Adaptacyjne reagowanie na zakłócenia w łańcuchu dostaw'
      ]
    },
    {
      id: 'produkcja',
      title: 'Smart Factory',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
          <path d="M17 18h1"></path>
          <path d="M12 18h1"></path>
          <path d="M7 18h1"></path>
        </svg>
      ),
      title2: 'Produkcja przemysłowa',
      description: 'Kompleksowa automatyzacja linii produkcyjnych',
      benefits: [
        'Zwiększenie wydajności o 27%',
        'Redukcja kosztów utrzymania ruchu o 35%',
        'Optymalizacja procesów produkcyjnych w czasie rzeczywistym',
        'Predykcyjne utrzymanie ruchu minimalizujące nieplanowane przestoje'
      ]
    }
  ];

  const switchTab = (tabId) => {
    setActiveTab(tabId);
  };
  
  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return (
    <section className="applications" id="applications">
      <div className="container">
        <h2 className="section-title">Zastosowania MINERVA</h2>
        <p className="section-subtitle">
          Nasza platforma znajduje zastosowanie w kluczowych branżach, oferując przewagę 
          konkurencyjną i wymierne oszczędności operacyjne
        </p>
        
        {/* Tab Buttons */}
        <div className="app-tabs">
          {tabs.map(tab => (
            <button 
              key={tab.id}
              className={`app-tab ${activeTab === tab.id ? 'active' : ''}`} 
              onClick={() => switchTab(tab.id)}
            >
              <div className="tab-icon">{tab.icon}</div>
              <span className="tab-title">{tab.title}</span>
            </button>
          ))}
        </div>
        
        {/* Tab Content */}
        <div className="app-content">
          <div className="app-content-inner">
            <div className="app-content-visual">
              <div className={`app-visual app-visual-${activeTab}`}>
                <div className="visual-overlay"></div>
              </div>
            </div>
            
            <div className="app-content-text">
              <h3>{activeTabData.title2}</h3>
              <p className="app-description">{activeTabData.description}</p>
              
              <h4>Kluczowe korzyści:</h4>
              <ul className="app-benefits">
                {activeTabData.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              
              <div className="app-cta">
                <a href="#contact" className="button button-primary">Poznaj szczegóły rozwiązania</a>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default Applications;